/* eslint-disable @typescript-eslint/camelcase */

import typewriter from '../shared/analytics';
import { SearchState } from 'react-instantsearch-core';

const getAnalytics: () => SegmentAnalytics.AnalyticsJS | undefined = () => {
    return window.analytics;
};

type TrackPageCallProps = {
    cmp?: string;
};

type TrackProductListFilteredProps = {
    appliedFilters: Filters;
    filterApplied: string;
    filterWidgetType: string;
    resultsCount: number;
    searchQuery: string;
    tab: string;
};

type TrackProductListViewedProps = {
    searchQuery: string;
    tab: string;
};

export type Filters = { attribute: string; value: string }[];

export type ProductListFilteredDataProps = {
    appliedFilters: Filters;
    lastAppliedFilter: string;
    lastAppliedValue: string;
    filterWidgetType: string;
    searchQuery: string;
};

type TrackSearchResultClickedProps = {
    departments?: string[];
    searchQuery: string;
    tab: string;
    title: string;
    type: string;
};

type trackSortAppliedProps = {
    searchQuery: string;
    sort: string;
    tab: string;
};

export const trackPageCall = ({ cmp }: TrackPageCallProps) => {
    type pageProps = {
        content_type: string;
        cmp_trackingcode?: string;
    };
    const analytics = getAnalytics();
    const props: pageProps = {
        content_type: 'Search',
    };
    if (cmp) {
        props.cmp_trackingcode = cmp;
    }
    analytics.page('Search', props);
};

// This listener is applied to links immediately rather than being called onClick,
// we won't be going through Typewriter since we want to use trackLink
export const addTrackingListenerToLink = ({
    link,
    departments,
    searchQuery,
    tab,
    title,
    type,
}: TrackSearchResultClickedProps & { link: HTMLLinkElement }) => {
    const analytics = getAnalytics();
    const props = {
        item_type: type,
        result_type: tab,
        search_keyword: searchQuery,
        search_result_category: type,
        search_result_department: departments,
        search_result_title: title,
    };
    analytics.trackLink(link, 'Search Result Clicked', props);
};

export const productListFilteredDataEmptyState = {
    appliedFilters: [] as Filters,
    lastAppliedFilter: '',
    lastAppliedValue: '',
    searchQuery: '',
    filterWidgetType: '',
};

export const trackProductListFiltered = ({
    appliedFilters,
    filterApplied,
    filterWidgetType,
    resultsCount,
    searchQuery,
    tab,
}: TrackProductListFilteredProps) => {
    const filters: string[] = [];
    appliedFilters.map((filter) => filters.push(`${filter.attribute}:${filter.value}`));
    const props = {
        collection: tab,
        filter_applied: filterApplied,
        filter_widget_type: filterWidgetType,
        filters: filters,
        list_id: tab,
        num_search_filters: filters.length,
        num_search_results: resultsCount,
        search_keyword: searchQuery,
        type: 'Search',
    };
    typewriter.productListFiltered(props);
};

export const trackProductListViewed = ({ searchQuery, tab }: TrackProductListViewedProps) => {
    const props = {
        collection: tab,
        list_id: tab,
        search_keyword: searchQuery,
        type: 'Search',
    };
    typewriter.productListViewed(props);
};

export const trackSortApplied = ({ searchQuery, sort, tab }: trackSortAppliedProps) => {
    const props = {
        collection: tab,
        list_id: tab,
        search_keyword: searchQuery,
        sort_type: sort,
    };
    typewriter.sortApplied(props);
};

export const updateProductListFilteredTrackingData = ({
    searchState,
    trackingData,
    setTrackingData,
}: {
    searchState: SearchState;
    trackingData: ProductListFilteredDataProps;
    setTrackingData: (value: ProductListFilteredDataProps) => void;
}) => {
    const { refinementList, sliderPricePosLow, sliderPricePosHigh, query } = searchState;
    const trackingDataNew: ProductListFilteredDataProps = productListFilteredDataEmptyState;
    trackingDataNew.searchQuery = query ? query : '';
    const appliedFiltersPrev = trackingData.appliedFilters;
    const filters: Filters = [];
    if (sliderPricePosLow !== undefined && sliderPricePosHigh !== undefined) {
        filters.push({
            attribute: 'price',
            value: `${sliderPricePosLow}-${sliderPricePosHigh}`,
        });
        if (
            !appliedFiltersPrev.find(
                (filterApplied) =>
                    filterApplied.attribute === 'price' &&
                    filterApplied.value === `${sliderPricePosLow}-${sliderPricePosHigh}`,
            )
        ) {
            trackingDataNew.lastAppliedFilter = 'price';
            trackingDataNew.filterWidgetType = 'slider';
            trackingDataNew.lastAppliedValue = `price:${sliderPricePosLow}-${sliderPricePosHigh}`;
        }
    }

    if (refinementList && Object.keys(refinementList).length) {
        for (const [key, refinementValue] of Object.entries(refinementList)) {
            if (
                refinementValue.length <
                appliedFiltersPrev.filter((filterAppliedPrev) => filterAppliedPrev.attribute === key).length
            ) {
                trackingDataNew.lastAppliedFilter = key;
                trackingDataNew.filterWidgetType = 'refinementList';
            }
            if (!refinementValue) {
                continue;
            }
            refinementValue.map((value) => {
                if (
                    !appliedFiltersPrev.find(
                        (filterApplied) => filterApplied.attribute === key && filterApplied.value === value,
                    )
                ) {
                    trackingDataNew.lastAppliedFilter = key;
                    trackingDataNew.filterWidgetType = 'refinementList';
                    trackingDataNew.lastAppliedValue = `${key}:${value}`;
                }
                filters.push({ attribute: key, value });
            });
        }
    }
    trackingDataNew.appliedFilters = filters;
    setTrackingData(trackingDataNew);
};
